import { Component, OnInit, ElementRef, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SessionExpiredService } from '../services/session-expired-service';
import { interval, Observable, Subscription } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { IAppConfig } from '../core/models/app-config.model';
import { AppConfigService } from '../core/services/app-config.service';
import { HttpClient } from '@angular/common/http';
import { IApiResponse } from '../core/models/api-response.model';
import { LogoutService } from "../core/services/logout.service";
@Component({
    selector: 'app-session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionExpiredComponent implements OnInit, OnDestroy {
    ngOnDestroy(): void {
        this.myInterval.unsubscribe();
        this.numbers.unsubscribe();
    }
    isOpened: boolean;
    timeLeft: any;
    myInterval: Subscription;
    numbers: Subscription;
    lastTimeLeft: any;
    isShow: boolean = true;
    secs: any;
    private appConfig: IAppConfig = {} as IAppConfig;
    ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true
    };

    modalref: any;
    popupTime = 5 * 60;
    
    @ViewChild('content') content: ElementRef;
    constructor(private _sessionExpiredService: SessionExpiredService,
      private modalService: NgbModal,
      public router: Router,
      private appConfigService: AppConfigService,
      private msalAuthService: MsalService,
      private http: HttpClient,
      private logoutService: LogoutService
    ) {
      this.initializeAppConfig();
    }
    ngOnInit() {
        this.numbers = interval(1000).subscribe(val => {
            this.checkTimeLeft();
        });

        this.myintr();

    }
   

    
  initializeAppConfig(): void {
    this.appConfig = this.appConfigService.get();
  }


    show() {
        if (this.isOpened) {
            return;
        }
        this.isOpened = true;
        this.modalref = this.modalService.open(this.content, this.ngbModalOptions);

    }
    checkTimeLeft() {
        this.timeLeft = this._sessionExpiredService.getTimeLeft();
        this.secs = Math.round(((this.timeLeft / 1000) / 60) * 60);
        if (this.secs <= this.popupTime) {
            this.show();
        }
    }
    refreshSession() {
        this.modalref.close();
        this._sessionExpiredService.resetTimer();
        this.isOpened = false;
    }

    navigateToTimeout() {
      if (this.modalref) {
        this.modalref.close();
      }
      if (this.myInterval) {
        this.myInterval.unsubscribe();
      }
      if (this.numbers) {
        this.numbers.unsubscribe();
      }
      console.log("Session expired");

      // Ensure logout is only called once to prevent infinite loop
      if (this.isOpened) {
        this.isOpened = false; // Prevent re-triggering
        this.logoutService.logout();
      }
    }
    //navigateToTimeout() {
       
    //    this.modalref.close();
    //    this.myInterval.unsubscribe();
    //    this.numbers.unsubscribe();
    //  console.log("Session expired");
    //  //  const logoutUrl = this.getLogoutUrl();

    //  //  // call backend service and blacklist the bearerv token
    //  //this.http.post<IApiResponse<boolean>>(logoutUrl, {}).subscribe({
    //  //    next: (res: IApiResponse<boolean>) => {
    //  //      this.msalLogout();
    //  //    },
    //  //    error: () => {
    //  //      this.msalLogout();
    //  //      console.log("Error while logging out");
    //  //    }
    //  //  });
    //  this.logoutService.logout();
    //}

    close() {
        this.modalref.close();
    };


    timeLeftOver() {        
        const mins = Math.trunc(this.secs / 60);
        let seconds: any = Math.floor((this.secs * 1000 % (1000 * 60)) / 1000);
        if (seconds <= 9) {
            seconds = "0" + seconds;
          }
        const remainingSeconds = mins + ':' + seconds;
        return remainingSeconds;
    };

    myintr() {
        this.myInterval = interval(1000).subscribe(val => {
            if (this.timeLeft !== this.lastTimeLeft) {
                this.lastTimeLeft = this.timeLeft;
            }
        });
    }

      /**
 * Method to get logout URL
 * @returns The parsed logout URL
 */
  getLogoutUrl() {
    const baseUrl = this.appConfig.session.baseUrl;
    const logout = this.appConfig.session.logout;
    return `${baseUrl + logout}`;
  }

  /**
   * Method to logout from browser using msal
   */
  msalLogout() {
    this.msalAuthService.logoutRedirect({
      postLogoutRedirectUri: this.appConfig.postLogoutRedirectUri
    });
  }

}
